module.exports = __webpack_public_path__ + "img/3_153.ba11248f.png";